module.exports = __webpack_public_path__ + "static/york-pullman-6f5fe7096f96291d95ac4f62c4d1a7b6.png";